export default __webpack_public_path__ + "static/media/1936.67370245.png";